var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header"},[_c('h1',{staticClass:"page-header__title"},[_vm._v("\n    "+_vm._s(_vm.heading)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }